<template>
  <card id="overview" :title="$t('f-overview:overview', {count: totalCount})" no-footer>
    <div slot="card-body">
      <div class="row">
        <div class="col-lg-6 mb-3">
          <h4>{{ $t('f-overview:cpu') | capitalize }}</h4>

          <div class="row">
            <div class="col-lg-4">
              <h5>{{ $t('f-overview:alarm') | capitalize }}</h5>
              <donut :total-count="totalCount" :last-events-counters="lastEventsCounters" attribute="CPU" />
            </div>
            <div class="col-lg-8">
              <h5>{{ $t('f-overview:distribution') | capitalize }} (%)</h5>
              <bars :update="update" :total-count="totalCount" attribute="CPU" />
            </div>
          </div>
        </div>

        <div class="col-lg-6 mb-3">
          <h4>{{ $t('f-overview:ram') | capitalize }}</h4>

          <div class="row">
            <div class="col-lg-4">
              <h5>{{ $t('f-overview:alarm') | capitalize }}</h5>
              <donut :total-count="totalCount" :last-events-counters="lastEventsCounters" attribute="RAM" />
            </div>
            <div class="col-lg-8">
              <h5>{{ $t('f-overview:distribution') | capitalize }} (%)</h5>
              <bars :update="update" :total-count="totalCount" attribute="RAM" />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 mb-3">
          <h4>{{ $t('f-overview:systemDisk') | capitalize }}</h4>

          <div class="row">
            <div class="col-lg-4">
              <h5>{{ $t('f-overview:alarm') | capitalize }}</h5>
              <donut :total-count="totalCount" :last-events-counters="lastEventsCounters" attribute="SYSTEM_DISK" />
            </div>
            <div class="col-lg-8">
              <h5>{{ $t('f-overview:distribution') | capitalize }} (%)</h5>
              <bars :update="update" :total-count="totalCount" attribute="SYSTEM_DISK" />
            </div>
          </div>
        </div>

        <div class="col-lg-6 mb-3">
          <h4>{{ $t('f-overview:userDisk') | capitalize }}</h4>

          <div class="row">
            <div class="col-lg-4">
              <h5>{{ $t('f-overview:alarm') | capitalize }}</h5>
              <donut :total-count="totalCount" :last-events-counters="lastEventsCounters" attribute="USER_DISK" />
            </div>
            <div class="col-lg-8">
              <h5>{{ $t('f-overview:distribution') | capitalize }} (%)</h5>
              <bars :update="update" :total-count="totalCount" attribute="USER_DISK" />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <h4>{{ $t('f-overview:rssi') | capitalize }}</h4>

          <div class="row">
            <div class="col-lg-4">
              <h5>{{ $t('f-overview:alarm') | capitalize }}</h5>
              <donut :total-count="totalCount" :last-events-counters="lastEventsCounters" attribute="RSSI" />
            </div>
            <div class="col-lg-8">
              <h5>{{ $t('f-overview:distribution') | capitalize }} (dBm)</h5>
              <bars :update="update" :total-count="totalCount" attribute="RSSI" />
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <h4>{{ $t('f-overview:temperature') | capitalize }}</h4>

          <div class="row">
            <div class="col-lg-4">
              <h5>{{ $t('f-overview:alarm') | capitalize }}</h5>
              <donut :total-count="totalCount" :last-events-counters="lastEventsCounters" attribute="TEMPERATURE" />
            </div>
            <div class="col-lg-8">
              <h5>{{ $t('f-overview:distribution') | capitalize }} (°C)</h5>
              <bars :update="update" :total-count="totalCount" attribute="TEMPERATURE" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import Donut from './OverviewDonut'
import Bars from './OverviewBars'

export default {
  components: { Donut, Bars },

  props: {
    // Update time, used to trigger and update from parent
    update: {
      type: Number,
      required: true
    },
    // Total of gateways to calculate %
    totalCount: {
      type: Number,
      required: true
    },
    // Last event counters for alarms
    lastEventsCounters: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  h5 {
    // Two lines
    min-height: 38px;
  }
</style>
